export const MoneyFormat = (money) => {
    let usDollar = new Intl.NumberFormat('en-US')
    return usDollar.format(money)
}